export default {
  placeholder: 'Pesquisar restaurante...',
};
